export default "August 25, 2018";